import React, {useMemo} from "react";
import {LinkWithParams, useNavigateWithParams} from "../util/NavUtils";
import {HeaderNavLinks} from "./HeaderNavLinks";
import {useProviderProfile} from "../ProviderProfileProvider";
import {useKensuAuth} from "../util/authwrapper/AuthWrapper";
import {Link} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import { ActionButton } from "../util/UI/ActionButton";
import {useAuthUtil} from "../util/AuthUtil";

interface Props {
}

export const Header = (props: Props) => {

  const {business} = useProviderProfile();
  const {user, isLoading, logout} = useKensuAuth();
  const navigate = useNavigateWithParams();
  const {auth0Login} = useAuthUtil();
  const host = window.location.host

  return <div className={'Header'}>

    {/* Whether there's a business loaded or not is a good proxy for whether the
             nav links should be shown! */}
    {business && <HeaderNavLinks/>}

    <div className={'HeaderLeftElement'}>
      <LinkWithParams style={{display: 'flex', justifyContent: 'left'}} to={'/'}>
        <img alt={'Kensu Logo'} src={require('../images/kensulogo.png')}
             className={'HeaderLogo DarkModeInvert'}/>
      </LinkWithParams>
      {host.startsWith("localhost") && <span style={{color: 'var(--green)'}}>local&nbsp;</span>}
      {host.endsWith("thymebook.com") && <span style={{color: 'var(--red)'}}>dev&nbsp;</span>}
    </div>

    {!user && !isLoading && <div><ActionButton onClick={() => auth0Login('/home')}>LOGIN</ActionButton></div>}

    
    {user && <div className={'HeaderRightElement'}>
      <ActionButton onClick={() => navigate('/home')}>DASHBOARD</ActionButton>
      {/*<Link to={'/home'}>Dashboard</Link>*/}
      <ActionButton secondary onClick={() => logout({
        logoutParams: {
          // Chooses correctly between localhost, thymebook.com, etc.
          returnTo: window.location.origin
        }
      })}>LOGOUT
      </ActionButton>
    </div>}
  </div>;
} 